import {
  useLocationLegacy as useLocation,
  NavigateLegacy as Navigate,
} from '@leagueplatform/routing';

export const MemberPathRedirect = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{
        ...location,
        // Removes first path string before non character value (/, ?, etc), e.g. /old-path/same -> /same
        pathname: location.pathname.replace(/^\/[\w-]+/, ''),
      }}
      replace
    />
  );
};
